import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalStorageService } from 'src/app/services/utils/local-storage.service';
import { SsoService } from 'src/app/services/resources/sso.service';
import { NavigateService } from 'src/app/services/utils/navigate.service';
import { OperatorService } from 'src/app/services/resources/operator.service';

@Component({
  selector: 'app-redirect-sso',
  templateUrl: './redirect-sso.component.html',
  styleUrls: ['./redirect-sso.component.scss']
})
export class RedirectSsoComponent implements OnInit {

  ssoInformation: any = null

  constructor(
    private activatedRoute: ActivatedRoute,
    public localStorageService: LocalStorageService,
    public ssoService: SsoService,
    public navigateService: NavigateService,
    public operatorService: OperatorService
  ) { }

  ngOnInit(): void {
    this.ssoInformation = this.localStorageService.getCurrentSsoInformation()

    this.activatedRoute.queryParams.subscribe((query) => {
      if (this.ssoInformation
        && this.ssoInformation.subDomain
        && this.ssoInformation.data
        && this.ssoInformation.data.ssoLogin
        && this.ssoInformation.data.ssoLogin.ssoAccessTokenQueryName
        && this.ssoInformation.data.ssoLogin.redirectUrl
        && query[this.ssoInformation.data.ssoLogin.ssoAccessTokenQueryName]
      ) {
        this.navigateService.goTo('sso', { ssoToken: query[this.ssoInformation.data.ssoLogin.ssoAccessTokenQueryName] })
      } else {
        console.log('Error on ssoAccessTokenQueryName', query)
        this.navigateService.goToNotFound()
      }
    })
  }

}
